import {useCustomer} from './useCustomer';

export function useCustomerMutationId() {
    const {customerData} = useCustomer();
    return customerData.mutationId;
}
